import { PathGraph } from './graphUtils/pathGraph';
import { MaybeNil } from '../../../utils/interfaces';
import { IParsedChartDataPath, OthersConfigAction } from '../interfaces';
import { ElementOf } from 'ts-essentials';
import { PathModeKey } from '../../../utils/apollo/graphqlSchema';

export type IChartDataFlow = ElementOf<
  (IParsedChartDataPath & { mode: PathModeKey.Sankey })['slices']
>;

export interface IParsedFlow
  extends Pick<IChartDataFlow, 'key' | 'name' | 'userAlias' | 'originalHint'> {
  graph: PathGraph;
  groupIndex: number;
}

export interface IPathLink {
  sourceId: string;
  targetId: string;
  value: number;
  groupIndex: number;
  visible: boolean;
  colorIndex: number;
  isHighlight: boolean;
}

export interface IMergedNodeSummary {
  key: string;
  name: string;
  incomingCount: number;
  seq: number;
  othersConfigAction: OthersConfigAction | undefined;
}

export interface IPathNodeDisplayProps {
  incomingCount: number;
  incomingCountFromOther: number;
  outgoingCount: number;
  fixedValue?: number;
  mergedNodes: IMergedNodeSummary[];
  incomingTotalPerSeq: number;
  othersConfigAction: OthersConfigAction | undefined;
}

export interface IPathNode extends IPathNodeDisplayProps {
  key: string;
  groupName: string;
  groupIndex: number;
  id: string;
  name: string;
  seq: number;
  nodeScore: number;
  visible: boolean;
  textVisible: boolean;
  colorIndex: number;
  groupAlias: IChartDataFlow['userAlias'];
  groupHint: IChartDataFlow['originalHint'];
}

export interface ISankeyLink extends IPathLink {
  y0: number;
  y1: number;
  width: number;
  index: number;
  source: ISankeyNode;
  target: ISankeyNode;
}

export interface ISankeyNode extends IPathNode {
  x0: number;
  x1: number;
  y0: number;
  y1: number;
  sourceLinks: ISankeyLink[];
  targetLinks: ISankeyLink[];
  value: number;
  index: number;
  nodeGroup: MaybeNil<ISankeyNode[]>;
}

export interface ISankeyGraph {
  nodes: ISankeyNode[];
  links: ISankeyLink[];
}

export interface IDimensions {
  width: number;
  height: number;
}

export enum IMask {
  MASK_STRIPE_ID = 'mask-stripe',
  MASK_ALT_ID = 'mask-alt',
}

export enum NodeCustomizationScope {
  IN_THIS_STEP,
  IN_WHOLE_PATH,
}

export interface IPathNodeCustomizationInThisStep {
  scope: NodeCustomizationScope.IN_THIS_STEP;
  type: OthersConfigAction;
  name: string;
  seq: number;
}

export interface IPatNodeCustomizationWholePath {
  scope: NodeCustomizationScope.IN_WHOLE_PATH;
  type: OthersConfigAction;
  name: string;
}

export type IPathNodeCustomization =
  | IPathNodeCustomizationInThisStep
  | IPatNodeCustomizationWholePath;
